export class DhcMethodOrFunctionDescription {
    typeName: string;
    name: string;
    paramString: string;
}
